module.exports = __webpack_public_path__ + "static/media/photo3@2x.fef692a0.jpg";